import { render, staticRenderFns } from "./permitting-template-add.vue?vue&type=template&id=3a2d8982&scoped=true"
import script from "./permitting-template-add.vue?vue&type=script&lang=js"
export * from "./permitting-template-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2d8982",
  null
  
)

export default component.exports